<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
  <div class="container-fluid top">
    <div class="row">
      <div class="col-12 col-md-8">
        <h3 class="title-inbox">Ingresa tus datos</h3>
        <div class="alert alert-primary" role="alert" *ngIf="showAlert">
          Gracias <strong>{{user.name}} {{user.lastname}}</strong>, te has registrado exitosamente en Inbox, puedes
          comenzar a realizar tus
          pedidos con nosotros
        </div>
        <div class="row">
          <div class="form-group col-12 col-md-6">
            <input class="form-control" type="text" placeholder="Nombre" formControlName="name" required>
            <div *ngIf="submitted && f.name.errors?.required" class="invalid-feedback d-block">
              Campo obligatorio
            </div>
          </div>
          <div class="form-group col-12 col-md-6">
            <input class="form-control" type="text" placeholder="Apellido" formControlName="lastname" required>
            <div *ngIf="submitted && f.lastname.errors?.required" class="invalid-feedback d-block">
              Campo obligatorio
            </div>
          </div>
          <div class="form-group col-12 col-md-6">
            <select name="provinces" id="provinces" class="form-control" formControlName="province">
              <option value="" selected>Seleccione una provincia</option>
              <option [value]="p" *ngFor="let p of provinces">{{p}}</option>
            </select>
            <div *ngIf="submitted && f.province.errors?.required" class="invalid-feedback d-block">
              Campo obligatorio
            </div>
          </div>
          <div class="form-group col-12 col-md-6">
            <input class="form-control" type="phone" placeholder="Telefono" formControlName="phone" required>
            <div *ngIf="submitted && f.phone.errors?.required" class="invalid-feedback d-block">
              Formato de email no válido
            </div>
            <div *ngIf="submitted && f.phone.errors?.pattern" class="invalid-feedback d-block">
              Sólo debe incluir dígitos
            </div>
          </div>
          <div class="form-group col-12 col-md-12">
            <input class="form-control" type="email" placeholder="Email" formControlName="email" required>
            <div *ngIf="submitted && f.email.errors?.required" class="invalid-feedback d-block">
              Campo obligatorio
            </div>
            <div *ngIf="submitted && f.email.errors?.email" class="invalid-feedback d-block">
              Formato de email no válido
            </div>
          </div>
          <div class="form-group col-12 col-md-6">
            <input class="form-control" type="password" placeholder="Contraseña" formControlName="password" required>
            <div *ngIf="submitted && f.password.errors?.required" class="invalid-feedback d-block">
              Campo obligatorio
            </div>
          </div>
          <div class="form-group col-12 col-md-6">
            <input class="form-control" type="password" placeholder="Confirmar contraseña" required
              formControlName="passwordConfirmation">
            <div *ngIf="submitted && f.passwordConfirmation.errors" class="invalid-feedback">
              <div *ngIf="f.passwordConfirmation.errors.required">Campo requerido</div>
              <div *ngIf="f.passwordConfirmation.errors.mustMatch">Contraseña y Repetir contraseña deben coincidir</div>
            </div>
          </div>
          <div class="col-12 col-md-12 text-center text-md-left mb-3">
            <button type="submit" class="btn btn-primary rounded">
              REGISTRAR CUENTA
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <h3 class="title-inbox">Información de casillero</h3>
        <mat-card class="background accent">
          <h4 class="title">Dirección AEREA</h4>
          <p>NOMBRE DEL CLIENTE + IBX-0000</p>
          <p>Miami, FL 33166</p>
          <p>5401 NW 72nd Ave</p>
          <p>(305) 364-5238</p>
        </mat-card>
        <br>
        <br>
        <br>
        <mat-card class="background accent">
          <h4 class="title">Dirección MARITIMA</h4>
          <p>NOMBRE DEL CLIENTE + IBX-OCEAN</p>
          <p>Miami, FL 33166</p>
          <p>5401 NW 72nd Ave</p>
          <p>(305) 364-5238</p>
        </mat-card>
      </div>
    </div>
  </div>
</form>
